import { getSessionStorage } from '@utils/sessionStorage';
import { ProductDataProps } from '@framework/api/types/build';
import type {
  State,
  BldOptions,
  BldPeripherals,
  BldHelpInfo,
  InfoModals,
  BldMoreInfoProductData,
} from './types';

export const getBldOptions = (state: State): BldOptions => state.bldOptions;

export const getBldPeripherals = (state: State): BldPeripherals =>
  state.bldPeripherals;

export const getBldEntryVariantId = (state: State): string | number =>
  state.bldEntryVariantId;

export const getBldMoreInfoVariantId = (state: State): string | number =>
  state.bldMoreInfoVariantId;

export const getBldMoreInfoProductData = (
  state: State
): BldMoreInfoProductData => state.bldMoreInfoProductData;

export const getBldHelpInfo = (state: State): BldHelpInfo => state.bldHelpInfo;

export const getViewedSection = (state: State): string => state.viewedSection;

export const getSetBLDOptions = (
  state: State
): ((options: BldOptions) => void) => state.setBLDOptions;

export const getSetBldPeripherals = (
  state: State
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): ((bldPeripherals: BldPeripherals | any) => void) => state.setBldPeripherals;

export const getSetBLDEntryVariantId = (
  state: State
): ((variantId: string | number) => void) => state.setBLDEntryVariantId;

export const getSetBLDMoreInfoVariantId = (
  state: State
): ((variantId: string | number) => void) => state.setBLDMoreInfoVariantId;

export const getSetBLDMoreInfoProductData = (
  state: State
): ((productData: ProductDataProps, isLockedItem: boolean) => void) =>
  state.setBLDMoreInfoProductData;

export const getSetBLDHelpInfo = (
  state: State
): ((BldHelpInfo: BldHelpInfo) => void) => state.setBLDHelpInfo;

export const getInfoModals = (state: State): InfoModals => state.infoModals;

export const getSetInfoModals = (
  state: State
): ((infoModals: InfoModals) => void) => state.setInfoModals;

export const getPrevPath = (): string => getSessionStorage('prevPath');

export const getSetPrevPath = (state: State): ((pathname: string) => void) =>
  state.setPrevPath;

export const getCurrentPath = (): string => getSessionStorage('currentPath');

export const getSetCurrentPath = (state: State): ((pathname: string) => void) =>
  state.setCurrentPath;

export const getSetViewedSection = (
  state: State
): ((section: string) => void) => state.setViewedSection;
